import React, { useEffect, useState } from 'react';
import { Shield } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 w-full z-40" data-id="element-255">
      <div className="bg-white/95 backdrop-blur-md border-t border-warm-200 p-3 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]" data-id="element-256">
        <a href="https://emalia.lat/cart/48344374509818:1" id="btn-compra-sticky" className="relative overflow-hidden rounded-xl font-semibold text-center bg-primary-500 hover:bg-primary-600 text-white shadow-md block w-full py-3" data-id="element-257">
          <span className="relative z-10" data-id="element-258">Comprar $29.999</span>
          <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 pointer-events-none" data-id="element-259" />
        </a>
        <div className="flex items-center justify-center gap-1 mt-2 text-xs text-text-muted" data-id="element-260">
          <Shield className="w-3 h-3 text-primary-500" data-id="element-261" /> Garantía 7 días
        </div>
      </div>
    </div>;
}